import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'

export default class extends Controller {

  connect() {
  }

  change_room(event) {
    const urlParams = new URLSearchParams(window.location.search);
    const protocolId = urlParams.get('protocol_id') || $("#cage_protocol_id").val()
    const frame = document.getElementById('cage_type_turbo') as HTMLFormElement;
    const frameSrc = frame.getAttribute('data-src') || '';

    const params = new URLSearchParams();
    params.set('room_id', event.target.value);

    if (protocolId) {
      params.set('protocol_id', protocolId.toString());
    }

    const cageTypeElement = document.getElementById('cage_cage_type') as HTMLSelectElement | null;
    const cageTypeValue = cageTypeElement?.value;

    if (cageTypeValue) {
      params.set('cage[cage_type]', cageTypeValue);
    }

    frame.src = `${frameSrc}?${params.toString()}`;
  }
}
